function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIconWrapper } from '../../components/atoms/Icon/withIconWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IconHeart = function IconHeart(props, ref) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none",
    role: "img",
    ref: ref
  }, props), ___EmotionJSX("path", {
    d: "M20.9,3.7c-2.3-2-5.8-1.7-8,0.6L12,5.2l-0.8-0.9c-1.8-1.8-5.3-2.9-8-0.6C0.4,6,0.3,10.1,2.7,12.6l8.3,8.6c0.3,0.3,0.6,0.4,1,0.4s0.7-0.1,1-0.4l8.3-8.6C23.7,10.1,23.6,6,20.9,3.7z M19.9,11.2L12,19.4l-7.9-8.1c-0.8-0.8-1.2-2-1.1-3.1C3.1,7,3.6,6,4.5,5.2c0.7-0.6,1.4-0.8,2.2-0.8c1.1,0,2.3,0.5,3.1,1.3l2.2,2.4l2.4-2.4c0.8-0.9,1.9-1.3,3-1.3c0.9,0,1.6,0.3,2.3,0.8C20.5,5.9,21,7,21,8.1C21.1,9.3,20.6,10.4,19.9,11.2z"
  }));
};

export default withIconWrapper( /*#__PURE__*/forwardRef(IconHeart));
//# sourceMappingURL=IconHeart.js.map